module.exports = __webpack_public_path__ + "static/media/Low-Power Icon.b5143616.png";